import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function ksefPasswordValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (!value) return null; // Let the 'required' validator handle empty values

    // 15 - 32 characters
    if (value.length < 15 || value.length > 32) return { ksefPassword: true };

    const hasUpperCase = /[A-Z]/.test(value);
    const hasLowerCase = /[a-z]/.test(value);
    const hasNumeric = /[0-9]/.test(value);
    
    // 1 special char from the allowed set
    const hasSpecial = /[!@#$%^&*()\-_=+]/.test(value);
    
    // NO polish characters or other special characters
    // Entire string must be composed of ONLY a-z, A-Z, 0-9, and the allowed special chars.
    const hasValidCharsOnly = /^[a-zA-Z0-9!@#$%^&*()\-_=+]+$/.test(value);

    const isValid = hasUpperCase && hasLowerCase && hasNumeric && hasSpecial && hasValidCharsOnly;

    return isValid ? null : { ksefPassword: true };
  };
}
